import { IFilterOption } from "@faire/web-api/indigofair/data/IFilterOption";

import {
  CATEGORY_KEY_PREFIX,
  ALL_PRODUCTS_KEY,
  NEW_ARRIVALS_KEY,
} from "@faire/retailer/components/LoggedOutBrand/consts";

export const filterNonCategoryNodesCategoryFilterOptions = (
  categoryFilterOptions: IFilterOption[]
) => {
  const allProductsKey = `${CATEGORY_KEY_PREFIX}${ALL_PRODUCTS_KEY}`;
  const newArrivalsKey = `${CATEGORY_KEY_PREFIX}${NEW_ARRIVALS_KEY}`;

  const keysToRemove: Set<string> = new Set([allProductsKey, newArrivalsKey]);

  return categoryFilterOptions.filter(
    (category) => category.key && !keysToRemove.has(category.key)
  );
};
